import axios from 'axios'
import router from '../router'
import authState from '../utils/authState'
import { ElMessage } from 'element-plus'
import eventBus, { EventTypes } from '../utils/eventBus'

const request = axios.create({
  baseURL: '/api',
  timeout: 5000
})

// 请求拦截器
request.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  response => response.data,
  error => {
    // 处理令牌失效的情况
    if (error.response && error.response.status === 401) {
      const errorCode = error.response.data?.code;
      
      // 只有在TOKEN相关错误时才执行自动登出
      if (errorCode === 'TOKEN_EXPIRED' || errorCode === 'INVALID_TOKEN' || errorCode === 'NO_TOKEN') {
        // 如果用户当前已登录，才执行登出操作
        if (authState.isLoggedIn.value) {
          console.log('请求拦截器检测到令牌过期:', errorCode);
          
          // 清除本地存储的认证信息并触发事件
          // 注意：实际登出操作将由App.vue的事件处理器执行
          // 这确保了UI和路由的一致处理
          
          // 触发令牌失效事件 - 先触发事件，让App.vue处理登出和UI更新
          eventBus.emit(EventTypes.AUTH_TOKEN_EXPIRED, {
            code: errorCode,
            message: error.response.data?.message || '登录已过期',
            originalRequest: error.config
          });
          
          // 不在此处主动重定向，让事件处理器统一处理重定向逻辑
          // 这样避免了多处重定向造成的混乱
        }
      }
    }
    
    return Promise.reject(error)
  }
)

export default request 